<div class="bulletin-carousel">
  <div class="py-1">
    <app-my-carousel-swiper [config]="carouselOptions">
      <div class="swiper-slide" *ngFor="let item of bulletins?.list; let i = index">
        <div class="card rounded-xl border-0 shadow-sm">
          <div class="card-body">
            <!-- <h6 class="text-muted">{{ item.createdAt }}</h6>
            <hr class="p-0 m-0" /> -->
            <div [innerHTML]="item.text" class="text"></div>
            <div class="d-flex justify-content-between pt-3">
              <div class="d-flex" style="gap: 7px; color: salmon">
                <span (click)="handleLike(item.id, item)" style="cursor: pointer">
                  <i class="fa-{{ hasCheckedBulletin(item?.bulletinLikes) ? 'solid' : 'regular' }} fa-heart my-auto">
                  </i>
                </span>
                <span>{{ item?.bulletinLikes?.length }}</span>
              </div>
              <span class="my-auto"> -{{ item.appUser?.profileCharacterName || "Unknown" }} </span>
            </div>
          </div>
        </div>
      </div>
    </app-my-carousel-swiper>
  </div>
  <!-- <div class="bulletin-carousel__header">
    <div></div>
    <a routerLink="/bulletin">see more</a>
  </div> -->
</div>

<ng-template #bulletinForm let-modal>
  <div class="title">Start New Topic</div>
  <app-editor [(innerValue)]="bulletin.text"></app-editor>
  <div class="modal-footer">
    <button class="button-3 mr-1 error" [disabled]="bulletin?.hasSubmit" (click)="modalService.dismissAll()"><i
        class="fa-solid fa-times"></i> Cancel</button>
    <button class="button-3" (click)="bulletinStore()" [disabled]="bulletin?.hasSubmit"><i
        class="fa-solid fa-paper-plane"></i> Submit</button>
  </div>
</ng-template>